import React from 'react';
import TeaserCard, { TeaserCardProps } from './TeaserCard';

const TeaserNewsCard = (props: TeaserCardProps) => {
  return <TeaserCard {...props} variant="news" />;
};

export default TeaserNewsCard;
